import { createSelector } from 'reselect';
import { ICoreState } from '@core/types/store';

export const splitSizesSelector = createSelector(
  (state: ICoreState) => state.fixed!.SplitSizes,
  (blockName) => blockName
);
